import { openNewsOverlayFromDeepLink } from '@bjb/bjb-web-components/dist/components/jb-news-overlay/jb-news-overlay.js';

// The server renders the news-content endpoint as a template on the body, with the current language
// baked in and the news uid left as a placeholder for the client to fill (see
// AddNewsOverlayUrlTemplate.php). This lets a `#overlayNews=<uid>` deep link open the overlay on page
// load by resolving the content URL itself.
const NEWS_UID_PLACEHOLDER = '__newsUid__';

const template = document.body.dataset.newsContentUrlTemplate;
if (template && window.location.hash.includes('overlayNews')) {
  // Open once the page has finished loading. The modal traps focus on its chrome as it opens, which
  // is only reliably rendered on a settled page; opening mid-load (while this module evaluates) races
  // that and throws a focus-trap error.
  const open = () =>
    openNewsOverlayFromDeepLink((newsUid) => template.replace(NEWS_UID_PLACEHOLDER, encodeURIComponent(newsUid)));
  if (document.readyState === 'complete') {
    open();
  } else {
    window.addEventListener('load', open, { once: true });
  }
}
